import './ShenShaCard.css'
import React from 'react';
import { Sparkles } from 'lucide-react';
import TermTip from './TermTip';
import { getTerm } from '../data/glossary';

// 三组：按术语库倾向归类，徽章配色与弹卡倾向一致
const GROUPS = [
  { key: 'good', title: '吉神', tones: ['吉'] },
  { key: 'bad', title: '凶煞', tones: ['凶'] },
  { key: 'mixed', title: '吉凶参半', tones: ['参半', '中'] }
];

// bare=true 时只渲染内容体（供详情页「神煞/五行」tab 卡内嵌），否则自带卡片壳
const ShenShaCard = ({ baziResult, shenshaData, bare = false }) => {
  if (!baziResult) return null;

  // 拍平去重
  const seen = new Set();
  const all = [];
  if (shenshaData && typeof shenshaData === 'object') {
    Object.values(shenshaData).forEach((arr) => {
      (arr || []).forEach((name) => {
        if (name && !seen.has(name)) { seen.add(name); all.push(name); }
      });
    });
  }

  const bucket = { good: [], bad: [], mixed: [] };
  all.forEach((name) => {
    const tone = getTerm(name)?.tone;
    const grp = GROUPS.find((g) => g.tones.includes(tone)) || GROUPS[2];
    bucket[grp.key].push(name);
  });

  const hasAny = all.length > 0;

  const body = (
    <>
      {hasAny ? (
        <div className="shensha-groups">
          {GROUPS.map((g) => {
            const items = bucket[g.key];
            if (!items.length) return null;
            return (
              <div key={g.key} className="shensha-group">
                <div className={`shensha-group-title tone-${g.key}`}>{g.title}</div>
                <div className="shensha-badges">
                  {items.map((name, idx) => (
                    <TermTip key={`${g.key}-${idx}`} term={name} className={`shensha-badge ss-${g.key}`}>
                      {name}
                    </TermTip>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="shensha-empty">暂无神煞信息</div>
      )}
      <p className="shensha-foot">神煞按整盘取用，点按任一名目查看白话释义。</p>
    </>
  );

  if (bare) return body;

  return (
    <div className="card" id="section-shensha">
      <h2><Sparkles size={20} className="h2-icon" /> 神煞</h2>
      {body}
    </div>
  );
};

export default ShenShaCard;
